module.exports = __webpack_public_path__ + "static/media/showcase-physical-step-01.74f720d4.svg";